import { render } from "./manage-name.vue?vue&type=template&id=33cc130c&scoped=true&ts=true"
import script from "./manage-name.vue?vue&type=script&lang=ts"
export * from "./manage-name.vue?vue&type=script&lang=ts"

import "./manage-name.vue?vue&type=style&index=0&id=33cc130c&lang=scss&scoped=true"

import exportComponent from "/Users/ls/Documents/维思英才/webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33cc130c"]])

export default __exports__